<h1 mat-dialog-title>Unassign Staff</h1>
<div mat-dialog-content>
  <p>Are you sure you want to unassign staff for this client ?</p>
</div>
<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close>Cancel</button>
  <button mat-raised-button color="warn" [mat-dialog-close]="{ confirm: true }">Confirm</button>
</mat-dialog-actions>
